import { createAction, props, union } from '@ngrx/store';

import { DriverToAllocate } from '@app/features/allocate/models/driverToAllocate';
import { Vehicle } from '@global/infrastructure/interfaces/vehicle';

export const updateDriversAndVehiclesToAllocate = createAction(
  '[Allocate] Update Drivers And Vehicles To Allocate',
  props<{perm: {vehicle: Vehicle, drivers: DriverToAllocate[]}, temp: {vehicle: Vehicle, drivers: DriverToAllocate[]}}>()
);

export const updateAllocatedDriverToTempVehicle = createAction(
  '[Allocate] Update Allocated Driver To Temp Vehicle',
  props<{isSelected: boolean, driverId: string}>()
);

export const updateAllocatedDriverToPermVehicle = createAction(
  '[Allocate] Update Allocated Driver To Perm Vehicle',
  props<{isSelected: boolean, driverId: string}>()
);

export const updateMainDriverOfTempVehicle = createAction(
  '[Allocate] Update Main Driver Of Temp Vehicle',
  props<{driverId: string}>()
);

const all = union({
  updateDriversAndVehiclesToAllocate,
  updateAllocatedDriverToTempVehicle,
  updateMainDriverOfTempVehicle,
  updateAllocatedDriverToPermVehicle
});
export type AllocateActionsUnion = typeof all;
